import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';


const logsHandlers = {
    [constant.logs](state, action) {
        return action.payload;
    }
};


const logsAreaHandlers = {
    [constant.logsArea](state, action) {
        return action.payload;
    }
};


const loadingHandlers = {
    [constant.loading](state, action) {
        return { ...state, loading: action.payload };
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer({ loading: false }, loadingHandlers);
export const search = createReducer({ page: 1, pageSize: 10 }, searchHandlers);
export const logs = createReducer([], logsHandlers);
export const logsArea = createReducer([], logsAreaHandlers);

export const proxyExecuteData = combineReducers({
    loading,
    search,
    logs,
    logsArea
})








// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/proxyExecuteData/reducers.js